import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../firebase-config';
import { doc, getDoc } from 'firebase/firestore';


function LmsModuleDetails() {
    const { packageId, batchId, courseId, moduleId } = useParams();
    const [module, setModule] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!moduleId) {
            setError('No module ID provided');
            setLoading(false);
            return;
        }

        const fetchModule = async () => {
            try {
                // Fetch module by ID
                const moduleDocRef = doc(db, 'lms_module', moduleId);
                const moduleDocSnap = await getDoc(moduleDocRef);

                if (!moduleDocSnap.exists()) {
                    setError('Module not found');
                    setLoading(false);
                    return;
                }

                const moduleData = moduleDocSnap.data();
                setModule({ id: moduleId, ...moduleData });

                setLoading(false);
            } catch (err) {
                console.error('Failed to fetch module:', err);
                setError('Failed to fetch module');
                setLoading(false);
            }
        };

        fetchModule();
    }, [moduleId]);

    if (loading) {
        return (
            <>
              
                <div className="bg-black min-h-screen text-white font-poppins p-6 flex flex-col items-center">
                    <p>Loading...</p>
                </div>
             
            </>
        );
    }

    if (error || !module) {
        return (
            <>
               
                <div className="bg-black min-h-screen text-white font-poppins p-6 flex flex-col items-center">
                    <p>{error || 'Module not found'}</p>
                </div>
              
            </>
        );
    }

    return (
        <>
         
            <div className="bg-black min-h-screen text-white font-poppins p-6 flex flex-col items-center">
                <div className="max-w-4xl w-full">
                    {/* Module Details */}
                    <h1 className="text-[1.75rem] font-medium leading-9 bg-custom-gradient bg-clip-text text-transparent mb-4">
                        {module.moduleName || `Module ${module.id}`}
                    </h1>
                    <div className=" rounded-xl p-6 mb-6">
                        <ul className="flex flex-col gap-2 list-none">
                            {module.moduleDescription && (
                                <div
                                    className="text-xl font-normal text-white leading-9 mb-4"
                                    dangerouslySetInnerHTML={{ __html: module.moduleDescription }}
                                />
                            )}
                            {module.createdAt && (
                                <li className="flex items-center gap-2 text-[1.2rem] font-normal text-white leading-[2.125rem]">
                                    <span className="w-2 h-2 rounded-full bg-custom-gradient"></span>
                                    Created: {new Date(module.createdAt).toLocaleDateString()}
                                </li>
                            )}
                            {module.updatedAt && (
                                <li className="flex items-center gap-2 text-[1.2rem] font-normal text-white leading-[2.125rem]">
                                    <span className="w-2 h-2 rounded-full bg-custom-gradient"></span>
                                    Updated: {new Date(module.updatedAt).toLocaleDateString()}
                                </li>
                            )}
                            <li className="flex items-center gap-2 text-[1.2rem] font-normal text-white leading-[2.125rem]">
                                <span className="w-2 h-2 rounded-full bg-custom-gradient"></span>
                                Module ID: {module.id}
                            </li>
                        </ul>
                    </div>

                 
                    <div className="bg-card-bg rounded-xl p-5 flex flex-col gap-2">
                        {module.moduleContent ? (
                            <>
                                {module.moduleContentType === 'video' && (
                                    <video
                                        controls
                                        className="w-full max-h-[32rem] object-contain rounded-lg bg-black"
                                    >
                                        <source src={module.moduleContent} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                )}
                                {module.moduleContentType === 'pdf' && (
                                    <iframe
                                        src={module.moduleContent}
                                        className="w-full h-[600px] rounded-lg border-0"
                                        title={module.moduleName || `Module ${module.id} PDF`}
                                    />
                                )}
                            </>
                        ) : (
                            <p className="text-[1.2rem] font-normal text-white leading-[2.125rem]">
                                No content available for this module.
                            </p>
                        )}
                    </div>
                </div>
            </div>
          
        </>
    );
}

export default LmsModuleDetails;